import { useTranslation } from "react-i18next";
import { useDecision } from "@optimizely/react-sdk";
import PhotoTransformationsModal from "../modals/PhotoTransformationsModal";
import TransformationsModelModal from "../modals/TransformationsModelModal";
import { RowInfo, FormAutocomplete } from "../../common";
import { Textarea } from "../../common/Textarea";
import NubImageUpload from "../../common/NubImageUpload";
import NubImageUploadModal from "../modals/NubImageUploadModal";
import { useState } from "react";

const Photo = ({ useQuery }) => {
    const { t } = useTranslation();
    const [decisionPhotoTransformations] = useDecision('photo_transformations');
    const [collection, setCollection] = useQuery();
    const [localPrompt, setLocalPrompt] = useState(collection.prompt);

    const setPrompt = (value) => {
        setCollection({
            // Set task_subtype to 0, if the transformation input is empty. 
            // Set task_subtype to 1, if the transformation input has at least 10 characters.
            // Set the prompt to the contents of the transformations input field. 
            // Ensure the input field is text-only, strip any HTML, hidden characters, line breaks, tabs etc.
            prompt: value?.length >= 10 ? value : '',
            task_subtype: value?.length >= 10 ? 1 : 0,
        });

        // Update the local prompt with the sanitized value.
        // If the value is empty, skip the update so the input is not cleared.
        // i.e. it is fine to have a different value in the local state vs the collection.
        // This new behavior is introduced in {ticket:617}
        if (value?.length > 0) {
            setLocalPrompt(value)
        }
    }

    const handleChange = (value) => {
        setLocalPrompt(value)
    }

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: t('Require the player to submit an image.') }} />
            {
                decisionPhotoTransformations?.enabled
                    ? (
                        <>
                            <RowInfo help={<NubImageUploadModal />} isFull>
                                <NubImageUpload 
                                    label={t("Transformation Reference Images (optional)")}
                                    name="transformations_media"
                                    useQuery={useQuery}
                                    maxImages={9}
                                />
                            </RowInfo>
                            <RowInfo help={<PhotoTransformationsModal />}>
                                <Textarea
                                    label={t("Transformation Instructions (optional)")}
                                    name="prompt"
                                    rows={5}
                                    mode="clean"
                                    defaultValue={localPrompt}
                                    setValue={setPrompt}
                                    onChange={handleChange}
                                    className="form-control reset-form-control"
                                    stripHtml={true}
                                />
                            </RowInfo>
                            <RowInfo help={<TransformationsModelModal />}>
                                <FormAutocomplete
                                    label={t("Transformations Model")}
                                    name="transformations_model"
                                    useQuery={useQuery}
                                    options={[
                                        { id: "0", name: t('OpenAI') },
                                        { id: "1", name: t('Google Gemini') },
                                        { id: "2", name: t('Google Gemini Pro 3') },
                                    ]}
                                    size="small"
                                    mode="clean"
                                />
                            </RowInfo>
                        </>
                    )
                    : null
            }
        </>
    )
};

export default Photo;
